import { HUB_PROGRAMS } from './entitlement.constant'

export const HOME_LINKS_ID = {
  THEATER: 'theater',
  SOUNDS: 'sounds',
  LIBRARY: 'library',
  LIBRARY3: 'library3',
  VOCAB: 'vocab_app',
  BIBLIOTECA: 'biblioteca',
  CAMINOS_BIBLIOTECA: 'caminos_biblioteca',
  CAMINOS_SONIDOS: 'caminos_sonidos',
  KNOWLEDGE_BUILDERS: 'knowledge-builders',
  CONSTRUCTORES_DE_CONOCIMIENTO: 'constructores-de-conocimiento',
  SONIDOS: 'sonidos',
  TEXAS_ELAR: 'texas_elar',
  TEXAS_SLAR: 'texas_slar',
}

export const PROGRAM_FILTERS = {
  ALL_APPS: 'ALL_APPS',
  CKLA: 'CKLA',
  CKLA3: 'CKLA3',
  CAMINOS: 'CAMINOS',
  TEXAS_ELAR: 'TEXAS_ELAR',
  TEXAS_SLAR: 'TEXAS_SLAR',
  TEXAS_IMRA_ELAR: 'TEXAS_IMRA_ELAR',
  TEXAS_IMRA_SLAR: 'TEXAS_IMRA_SLAR',
  TEXAS_IMRA_COMMERCIAL: 'TEXAS_IMRA_COMMERCIAL',
}

export const PROGRAM_FILTER_PROGRAM_MAP = {
  [PROGRAM_FILTERS.CAMINOS]: HUB_PROGRAMS.CAMINOS,
  [PROGRAM_FILTERS.CKLA]: HUB_PROGRAMS.CKLA,
  [PROGRAM_FILTERS.CKLA3]: HUB_PROGRAMS.CKLA3,
  [PROGRAM_FILTERS.TEXAS_ELAR]: HUB_PROGRAMS.TEXAS_ELAR,
  [PROGRAM_FILTERS.TEXAS_SLAR]: HUB_PROGRAMS.TEXAS_SLAR,
  [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: HUB_PROGRAMS.TEXAS_IMRA,
  [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: HUB_PROGRAMS.TEXAS_IMRA,
  [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL,
}

export const PROGRAM_FILTERS_NAMES = {
  [PROGRAM_FILTERS.ALL_APPS]: 'All',
  [PROGRAM_FILTERS.CAMINOS]: 'Caminos',
  [PROGRAM_FILTERS.CKLA]: 'CKLA 2nd Edition',
  [PROGRAM_FILTERS.CKLA3]: 'CKLA 3rd Edition',
  [PROGRAM_FILTERS.TEXAS_ELAR]: 'Texas ELAR',
  [PROGRAM_FILTERS.TEXAS_SLAR]: 'Texas SLAR',
  [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: 'Texas IMRA ELAR',
  [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: 'Texas IMRA SLAR',
  [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: 'Texas IMRA + Commercial Knowledge',
}

// for now, we don't All Apps filter anymore, but if we do in the future,
// we can just simply switch this flag
export const IS_ALL_APPS_FILTER_AVAILABLE = false
